import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class SpinRequestPayload extends RequestPayload {
    public creditPerLine: number;
    public creditSize: number;
}
